/* eslint-disable react/jsx-no-target-blank */
import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Import required modules
import { Autoplay, Parallax, Pagination, Navigation } from "swiper/modules";

import { useQuery } from "@tanstack/react-query";
import Loader from "../../../Component/Loader/Loader";
import { getFeature } from "../../../lib/Services_with_Query";

const Promotion = () => {
  const { data, isLoading, error } = useQuery({
    queryFn: () => getFeature(true),
  });

  const swiperRef = useRef(null);
  if (isLoading) return <Loader />;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <>
      <div className="col-xl-12 col-lg-12 col-md-12">
        <div className="section-headline text-center">
          <div className="section-center-head">
            <p
              className="top-head"
              style={{ marginTop: "20px", fontSize: "50px" }}
            >
              Promos {data?.length === 0 && "Not Found"}
            </p>
          </div>
        </div>
      </div>
      <Swiper
        style={{
          "--swiper-navigation-color": "#fff",
          "--swiper-pagination-color": "#fff",
        }}
        speed={600}
        ref={swiperRef}
        navigation={{
          prevEl: ".owl-prev",
          nextEl: ".owl-next",
        }}
        parallax={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Parallax, Pagination, Navigation]}
        className="mySwiper"
      >
        {data?.map((e, index) => (
          <SwiperSlide key={index}>
            <div
              className="image-container"
              style={{ width: "100%", textAlign: "center" }}
            >
              <a
                href={e?.link || "https://www.w3.org/Provider/Style/dummy.html"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{
                    maxWidth: "80%",
                    height: "auto",
                    display: "block",
                    margin: "0 auto",
                    objectFit: "cover",
                  }}
                  src={e?.image}
                  alt={`Slide ${index + 1}`}
                />
              </a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default Promotion;
